import { TLimitsRequest, TLimitsRequestType } from "src/@types/limits";
import GenericDAO from "../GenericDAO";

const route = "/v1/clients/:id/notes";

const getById = async (data: TLimitsRequest) => GenericDAO.replaceGetById(route, data.clientId, true);

export default {
    getById
};